module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/gear-6ea2335c061e7c212f84d225f136ce22.svg";